export const LOADER_TYPE_PAGE = 'page';
export const LOADER_TYPE_BACKGROUND = 'background';
